import axios from "axios";
import { crmHeaders } from "../utils/crmApi";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export async function fetchEmailAccountHealth({ country, email } = {}) {
    const params = {};
    if (country) params.country = country;
    if (email) params.email = email;

    const res = await axios.get(`${BASE_URL}/email-account-health`, {
        headers: crmHeaders(),
        params,
        timeout: 120000,
    });
    return {
        accounts: res.data?.accounts || [],
        checkedAt: res.data?.checkedAt || new Date().toISOString(),
        blockedCount: res.data?.blockedCount || 0,
        warningCount: res.data?.warningCount || 0,
    };
}
